import React, {useState,useMemo,useEffect} from 'react';
import {Link,Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ForwardIcon from '@mui/icons-material/Forward';
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Assignment';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Close';
import CopyToClipboard from 'react-copy-to-clipboard';
import {Inc,Dataset,Owner,Item,ItemSearchCondition} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Alert from './Alert';
import Yesno from './Yesno';
import Loading from './Loading';
import ItemListSearch from './ItemListSearch';
import ItemInput from './ItemInput';
import Toast from './Toast';
import StoreImg from './StoreImg';
import Title from './Title';
import AppBank from './AppBank';

interface ItemListProps {
	owner:Owner,
	managerId:number,
	bank:AppBank,
}
//let p:number = 1;

const ItemList = (pr:ItemListProps)=> {
    Ajax.setEditorId( pr.owner.owner_id );
	const classes = useStyles();

	const defPages:Dataset[] = [];
	const defItems:Item[] = [];
	const defCheckedIds:number[] = [];

	const [pages,setPages] = useState(defPages);
    const [states,setStates] = useState({
		items:defItems,
		checkedIds:defCheckedIds,
		allChecked:false,
        isLoading:true,
		isInput:false,
		currentPage:1,
		pager:null,
		yesno:"",
		alert:"",
		redirectId: 0,
        cond:Inc.defaultItemSearchCondition(),
    });
	const [toast,setToast] = useState('');
    const search = (cond:ItemSearchCondition,page:number)=>{
		setStates({...states,isInput:false,isLoading:true});
		// if( first )     {
		// 	p = 1;
		// }

		window.scrollTo(0,0);
        Ajax.search("item/list",cond,page,(res:any)=>{
            if( res.ok ){
                setStates({...states,items:res.items,cond:cond,currentPage:page,pager:res.pager,isInput:false,isLoading:false,checkedIds:[],allChecked:false,yesno:""});
            } else {
                setStates({...states,isInput:false,isLoading:false,yesno:""});
            }
        });
	}
	const jump = (to:number)=>{
		//send(values,p);
		//p = to;
		search(states.cond,to);
	}
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id)});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.items.length ; i++ ){
				ids.push( states.items[i].item_id );
			}
			setStates({...states,"checkedIds":ids,"allChecked":true});
		}
	}
	const remove = ()=>{
		//※「非公開」で、在庫が０の商品のみ
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"商品を選択して下さい"});
		} else {
			let error = false;
			for( let i=0 ; i<states.items.length ; i++ ){
				if( states.checkedIds.includes(states.items[i].item_id) ){
					if( states.items[i].status!=="0" || states.items[i].num_stock>0 ){
						error = true;
					}
				}
			}
			if( error ){
				setStates({...states,"alert":"「非公開」で在庫が０の商品以外は削除できません"});
			} else {
				setStates({...states,"yesno":"remove"});
			}
		}
	}
	const secret = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"商品を選択して下さい"});
		} else {
			setStates({...states,"yesno":"secret"});
		}
	}
	const yes = ()=>{
		if( states.yesno==="secret" ){
			Ajax.send("item/private",{item_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
		if( states.yesno==="remove" ){
			Ajax.send("item/hide",{item_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond,states.currentPage);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}
	const openInput = ()=>{
		setStates({...states,isInput:true});
	}
	const closeInput = (updated:boolean,id:number)=>{
		if( updated ){
			//search(states.cond);
			setStates({...states,redirectId:id,isInput:false});
		} else {
			setStates({...states,isInput:false});
		}
	}
	const copy = ()=>{
		setToast('クリップボードにURLをコピーしました');
	}
	const closeToast = ()=>{
		setToast('');
	}
    const getCategoryUrl = (item:Item)=>{
		let url = process.env.REACT_APP_STOREURL + "/list_c" + item.cat_id + ".html"; 
        return url;
    }

	const ItemRow = (props:{item:Item,owner_id:number})=>{
		const to = "/item/"+String(props.item.item_id);
		const v = states.checkedIds.includes(props.item.item_id);
		const toStore = Tools.getStoreUrl(props.item.item_id);
		const [open,setOpen] = useState(false);
		const toggle = ()=>{
			setOpen(!open);
		}
		//console.log(props.item);
		return (
			<>
			<TableRow>
				<TableCell className={classes.tableCellDense} style={{width:'2em'}}>
					<Checkbox
						checked={v}
						value={String(props.item.item_id)}
						onClick={()=>checkId(props.item.item_id)}
						color="primary"
						className={classes.listCheckbox}
					/>
				</TableCell>
				<Hidden smDown implementation="js">
					<TableCell className={classes.tableCellDense} align="center" style={{width:'5em',verticalAlign:'middle'}}><StoreImg owner_id={props.owner_id} img_id={props.item.img_id} thumb={true} className="imgList"/></TableCell>
				</Hidden>
				<TableCell className={classes.tableCellDense}>
					<span className={classes.itemId}>ID:{props.item.item_id}</span>　
					<Hidden smUp implementation="js">
						<br/>
					</Hidden>
					{props.item.item_name}<br/>
					{props.item.page_name !== "" &&
					<div className="with_page_name">{props.item.page_name}</div>
					}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right">{props.item.num_stock}</TableCell>
				<Hidden smDown implementation="js">
					{props.item.admit_flag ? (
					<TableCell className={classes.tableCellNowrap} align="center" style={{width:'5.5em'}}>
						{Tools.colorLabel("item_status",props.item.status,props.item.status_label)}<br/>
					</TableCell>
					):(
					<TableCell className={classes.tableCellNowrap} align="center" style={{width:'5.5em'}}>
						{Tools.colorLabel("item_status",props.item.status,'納品前')}<br/>
					</TableCell>
					)}
				</Hidden>
				<TableCell className={classes.tableCellNowrap} align="right" style={{width:'4em'}}>
					<IconButton style={{margin:'0',padding:'0',marginRight:'0.5em'}} onClick={toggle}><ArrowDropDownIcon/></IconButton>
					<Link to={to}><IconButton aria-label="edit" style={{margin:'0',padding:'0'}} className={classes.primary}><ForwardIcon/></IconButton></Link>
				</TableCell>
			</TableRow>
			{open &&
			<TableRow>
				<TableCell style={{ paddingBottom: '1em', paddingTop: 0, paddingLeft: 0, paddingRight: 0}} colSpan={9}>
					<Table><TableBody>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								画像
							</TableCell>
							<TableCell>
								<StoreImg owner_id={props.owner_id} img_id={props.item.img_id} thumb={false} className="imgItemLarge"/>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								商品ID
							</TableCell>
							<TableCell>
								{props.item.item_id}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								商品名
							</TableCell>
							<TableCell>
								{props.item.item_name}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								ラベル
							</TableCell>
							<TableCell>
								{props.item.promo_text}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								シリーズ
							</TableCell>
							<TableCell>
								{(!props.item.page_name || props.item.page_name==="") ? <span>なし</span> : <span>{props.item.page_name}</span>}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5',width:'40%'}}>
								価格
							</TableCell>
							<TableCell>
								{Tools.comma(props.item.price)}円
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								単位
							</TableCell>
							<TableCell>
								{props.item.unit}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								販売数の制限
							</TableCell>
							<TableCell>
								{props.item.upto>0 ? (
								<span>{props.item.upto}{props.item.unit}</span>
								):(
								<span>なし</span>
								)}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								在庫
							</TableCell>
							<TableCell>
								{props.item.num_stock}{props.item.unit}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								チャリティ
							</TableCell>
							<TableCell>
								{props.item.charity}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								カテゴリ
							</TableCell>
							{(props.item.admit_flag==='1' && props.item.cats) ? (
							<TableCell>
								<div style={{textAlign:"left",marginLeft:'-0.75em'}}>
									<a href={getCategoryUrl(props.item)} rel="noopener noreferrer" target="_blank"><Button variant="text" color="primary"><LaunchIcon/> {props.item.cats[0]} → {props.item.cats[1]}</Button></a>
								</div>
							</TableCell>
							):(
							<TableCell>
								不明
							</TableCell>
							)}
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								配送方法
							</TableCell>
							{props.item.admit_flag==='1' ? (
							<TableCell>
								{props.item.upack_flag==='1' ? (
									<>
									<Chip icon={<CheckIcon style={{color:'green'}}/>} label="ゆうパック" variant="outlined"/>
									<Chip icon={<CancelIcon style={{color:'red'}} />} label="ゆうパケット不可" />									
									</>
								):(
									<>
									<Chip icon={<CheckIcon style={{color:'green'}}/>} label="ゆうパック" variant="outlined"/>
									<Chip icon={<CheckIcon style={{color:'green'}} />} label="ゆうパケット" variant="outlined"/>									
									</>
								)}
							</TableCell>
							):(
							<TableCell>
								不明
							</TableCell>
							)}

						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								販売ページ
							</TableCell>
							<TableCell>
								<input type="text" value={toStore} readOnly style={{width:'80%',padding:'0.25em 0.1em',marginBottom:'0.25em'}}/>
								<div style={{textAlign:"left",marginLeft:'-0.5em'}}>
								<a href={toStore} rel="noopener noreferrer" target="_blank"><Button size="small" variant="text" color="primary"><LaunchIcon/> 販売ページを開く</Button></a>
								<CopyToClipboard text={toStore} onCopy={copy}>
									<Button variant="text" color="primary" size="small"><MessageIcon/> URLをコピー</Button>
								</CopyToClipboard>
								</div>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell style={{backgroundColor:'#F5F5F5'}}>
								状態表示
							</TableCell>
							{props.item.admit_flag ? (
							<TableCell>
								{Tools.colorLabel("item_status",props.item.status,props.item.status_label)}<br/>
							</TableCell>
							):(
							<TableCell>
								{Tools.colorLabel("item_status",props.item.status,'納品前')}<br/>
							</TableCell>
							)}
						</TableRow>
					</TableBody></Table>
				</TableCell>
			</TableRow>
			}
			</>
		);
	}
	const itemRows = useMemo(()=>{
		return states.items.map( (item:Item,index:number)=>{
			const key = "item"+index;
			return <ItemRow item={item} owner_id={pr.owner.owner_id} key={key}/>
		})
	},[states.items,states.checkedIds.join("_")])

	useEffect( ()=>{
		Ajax.send("item/pages",{},(res:any)=>{
			if( res.ok ){
				setPages(res.pages);
			}
		});
	},[]);

	if( states.redirectId>0 ){
		return <Redirect to={"/item/"+states.redirectId}/>
	}

	if( pr.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択した商品を削除します。\n本当によろしいですか？\n\n※削除した商品を元に戻すことはできませんのでご注意ください";
		}
		if( states.yesno==="secret" ){
			yesnoMes = "選択した商品を非公開にします。\nよろしいですか？";
		}
	}

	return (
		<div id="item_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="商品（本・雑貨）" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
                        	架空ストアに登録してある本・雑貨の商品一覧です。条件を指定して商品を検索することもできます。<br/>
							新しい商品を登録する場合は、「商品を登録」ボタンをクリックして下さい。<br/>
							<div className={classes.hintList}>
								※「状態表示」は「購入者から見た状態」です。実際には在庫があっても発売日が登録されていないと「在庫なし」または「非公開」の表示になります。
							</div>
							<Hidden mdUp implementation="js">
								<div style={{width:"100%",maxWidth:"160px",marginRight:"0",marginLeft:"auto"}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
									<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput}><AddIcon/>商品を登録</Button>
								</FormControl>
								</div>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>									
										
									</TableCell>
                                    <Hidden smDown implementation="js">
                                        <TableCell className={classes.tableHeadNowrap} align='center'>画像</TableCell>
                                    </Hidden>
									<TableCell className={classes.tableHeadNowrap} align='center'>商品ID/商品名</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableHeadNowrap} align='center'>状態表示</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>{itemRows}</TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・修正" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput}><AddIcon/>商品を登録</Button>
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックした商品を</div>
							<FormGroup row>
								<Button variant="outlined" color="secondary" size="small" onClick={secret} disabled={states.checkedIds.length===0}><VisibilityOffIcon/>非公開にする</Button>
								<Button variant="contained" color="secondary" size="small" onClick={remove} disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
							</FormGroup>
						</FormControl>
					</Paper>

                    <Paper className={classes.paper}>
                        <ItemListSearch pages={pages} useUpack={true} update={search} bank={pr.bank} bankKey={"savedItemListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>
			<ItemInput itemId={0} isOpen={states.isInput} owner={pr.owner} managerId={pr.managerId} close={closeInput}/>
            <Loading isLoading={states.isLoading}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""} danger={states.yesno==="remove"}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default ItemList;
